import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  OnInit,
  ViewChild
} from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import {
  AccountsService,
  CreateExpenseCommand,
  CurrenciesService,
  CurrencyRatesService,
  ExpensesService
} from '@api-accounting-client';
import { GridComponent } from '@progress/kendo-angular-grid';
import { DialogService } from '@progress/kendo-angular-dialog';
import { BudgetSheetsService } from '@api-client';

import { ExpenseFormBaseComponent } from '../expenseFormBaseComponent';
import { DialogExtendedService, NotificationsExtendedService } from '../../../shared/services';
import { SalesInvoiceDataSharingService } from '../../../shared/services/data-helper';
import { SideBarDataSharingService } from '../../../shared/services/side-bar';
@Component({
    selector: 'app-expense-add',
    templateUrl: './expense-add.component.html',
    styleUrls: ['./expense-add.component.scss'],
    standalone: false
})
export class ExpenseAddComponent
  extends ExpenseFormBaseComponent
  implements OnInit, AfterViewInit {
  @ViewChild('grid') grid: GridComponent;

  allAccounts: any[] = [];
  totalDebit = 0;
  totalCredit = 0;

  constructor(
    protected formBuilder: UntypedFormBuilder,
    protected accountsService: AccountsService,
    private cd: ChangeDetectorRef,
    protected expensesService: ExpensesService,
    protected dialogService: DialogService,
    protected currenciesService: CurrenciesService,
    protected dialogExtendedService: DialogExtendedService,
    protected notificationsExtendedService: NotificationsExtendedService,
    protected sideBarDataSharingService: SideBarDataSharingService,
    protected salesInvoiceDataSharingService: SalesInvoiceDataSharingService,
    protected currencyRatesService: CurrencyRatesService,
    protected budgetSheetsService: BudgetSheetsService,
    private route: ActivatedRoute,
  ) {
    super(
      formBuilder,
      expensesService,
      dialogService,
      accountsService,
      currenciesService,
      dialogExtendedService,
      notificationsExtendedService,
      sideBarDataSharingService,
      salesInvoiceDataSharingService,
      currencyRatesService,
      budgetSheetsService,
    );
  }

  onDataSubmit(command: CreateExpenseCommand) {
    return this.expensesService.expensesPost(command);
  }

  async ngOnInit() {
    super.ngOnInit();
    const projectUidFromQuery = this.route.snapshot.queryParamMap.get('projectUid');
    if (projectUidFromQuery) {
      this.form.patchValue({ projectUid: projectUidFromQuery });
    }
  }

  ngAfterViewInit(): void {
    this.cd.detectChanges();
  }
}
